
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBeaconTowerTShape as ObiBeaconTowerTShapeElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-beacon-tower-t-shape.js';
 
 
 

 
 export const ObiBeaconTowerTShape = createComponent({
   react: React,
   tagName: 'obi-beacon-tower-t-shape',
   elementClass: ObiBeaconTowerTShapeElement,
   events: {
     
   }
  });
 
 